module.exports = __webpack_public_path__ + "img/check-circle-colored.ac8e0ad1.svg";